import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '450px auto 550px',
    gridGap: '30px',
    justifyItems: 'center',
    alignItems: 'center',

    '& > *:nth-of-type(3)': {
      gridColumn: '1/3',
    },
    minWidth: 750,
  },

  plotWrapper: {
    height: '100%',
    width: '100%',
    paddingTop: '20px',
  },

  plotCard: {
    borderRadius: '10px',
    backgroundColor: 'white',
    paddingTop: '16px',
    height: 'calc(100% - 60px)',
    overflow: 'hidden',
    '@media(max-width: 900px)': {
      backgroundColor: 'initial',
      paddingTop: 0,
    },
  },

  tableClass: {
    display: 'grid',
    gridTemplateColumns: '3fr 2fr 1fr 1fr 2fr',
    rowGap: '17px',
    paddingBottom: '16px',
    overflowX: 'auto'
  },

  headerCell: {
    display: 'flex',
    height: '104px',
    padding: '30px',
    alignItems: 'center',
    color: '#102131',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: '0.43px',
    borderBottom: '2px solid rgba(20, 13, 56, 0.62)',
  },

  cell: {
    color: '#6D7883',
    letterSpacing: '-0.1px',
    padding: '16px 30px',
  },

  simpleItem: {
    marginBottom: '10px',
    borderRadius: '10px',
    color: '#6D7883',
    backgroundColor: 'white',
  },
  
  primaryText: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
  },

  secondaryText: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '12px',
    padding: '0px 16px 16px',
  },

  campaignName: {
    fontFamily: '"Manrope", sans-serif',
    fontSize: '16px',
    fontWeight: '600',
    marginRight: '20px',
  },

  campaignType: {
    fontSize: '14px',
  }
});
